import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Input } from "nav-frontend-skjema";
import Hjelpetekst from "./../";
export const _frontmatter = {
  "ingress": "Hjelpetekst er en knapp som kan åpne en <a href=\"/components/popover\">Popover</a> med kontekstuell informasjon."
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#normal"
          }}>{`Normal`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#kombinasjon-med-skjemafelt"
          }}>{`Kombinasjon med skjemafelt`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#posisjon-av-popup"
          }}>{`Posisjon av popup`}</a></li></ol></nav>
    <h2 {...{
      "id": "normal"
    }}>{`Normal`}</h2>
    <p>{`Hjelpetekst brukes når brukeren kan trenge mer informasjon, men hvor det ikke er naturlig
å bruke plass på det i grensesnittet. Dette kan for eksempel være for å forklare vanskelige
begreper, gi veiledning i utfylling av skjema-felter eller utdype bakgrunn for et regelverk.`}</p>
    <Example mdxType="Example">
  <Hjelpetekst mdxType="Hjelpetekst">
    Innholdet vil vises når brukeren klikker på knappen.
  </Hjelpetekst>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Hjelpetekst>Innholdet vil vises når brukeren klikker på knappen.</Hjelpetekst>
`}</code></pre>
    <h2 {...{
      "id": "kombinasjon-med-skjemafelt"
    }}>{`Kombinasjon med skjemafelt`}</h2>
    <p>{`For å enkelt knytte Hjelpetekst-komponenten til et skjemafelt kan komponenten sendes inn
via `}<inlineCode parentName="p">{`label`}</inlineCode>{`-propen til skjemafeltet. Se `}<a parentName="p" {...{
        "href": "/components/hjelpetekst/accessibility"
      }}>{`Tilgjengelighet`}</a>{`-fanen for andre måter å lage en assosiasjon mellom Hjelpetekst-komponenten og elementet den forsøker å beskrive.`}</p>
    <Example mdxType="Example">
  <Input id="min-input" label={<div style={{
        display: "flex"
      }}>
        Fødselsnummer
        <Hjelpetekst style={{
          marginLeft: "0.5rem"
        }} mdxType="Hjelpetekst">
          Innholdet vil vises når brukeren klikker på knappen.
        </Hjelpetekst>
      </div>} mdxType="Input" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Input
  id="min-input"
  label={
    <div style={{ display: "flex" }}>
      Fødselsnummer
      <Hjelpetekst>
        Innholdet vil vises når brukeren klikker på knappen.
      </Hjelpetekst>
    </div>
  }
/>
`}</code></pre>
    <h2 {...{
      "id": "posisjon-av-popup"
    }}>{`Posisjon av popup`}</h2>
    <p>{`Du kan bestemme hvor popup-ruten dukker opp.`}</p>
    <Example mdxType="Example">
  <Hjelpetekst type="over" mdxType="Hjelpetekst">Denne vil åpnes over knappen.</Hjelpetekst>&nbsp;
  <Hjelpetekst type="over-venstre" mdxType="Hjelpetekst">
    Denne vil åpnes over knappen, justert fra venstre kant.
  </Hjelpetekst>&nbsp;
  <Hjelpetekst type="over-hoyre" mdxType="Hjelpetekst">
    Denne vil åpnes over knappen, justert fra høyre kant.
  </Hjelpetekst>
  &nbsp;
  <Hjelpetekst type="under" mdxType="Hjelpetekst">Denne vil åpnes under knappen.</Hjelpetekst>&nbsp;
  <Hjelpetekst type="under-venstre" mdxType="Hjelpetekst">
    Denne vil åpnes under knappen, justert fra venstre kant.
  </Hjelpetekst>
  &nbsp;
  <Hjelpetekst type="under-hoyre" mdxType="Hjelpetekst">
    Denne vil åpnes under knappen, justert fra høyre kant.
  </Hjelpetekst>&nbsp;
  <Hjelpetekst type="venstre" mdxType="Hjelpetekst">
    Denne vil åpnes til venstre for knappen.
  </Hjelpetekst>
  &nbsp;
  <Hjelpetekst type="hoyre" mdxType="Hjelpetekst">Denne vil åpnes til høyre for knappen.</Hjelpetekst>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Hjelpetekst type="over">Denne vil åpnes over knappen.</Hjelpetekst>
<Hjelpetekst type="over-venstre">Denne vil åpnes over knappen, justert fra venstre kant.</Hjelpetekst>
<Hjelpetekst type="over-hoyre">Denne vil åpnes over knappen, justert fra høyre kant.</Hjelpetekst>
<Hjelpetekst type="under">Denne vil åpnes under knappen.</Hjelpetekst>
<Hjelpetekst type="under-venstre">Denne vil åpnes under knappen, justert fra venstre kant.</Hjelpetekst>
<Hjelpetekst type="under-hoyre">Denne vil åpnes under knappen, justert fra høyre kant.</Hjelpetekst>
<Hjelpetekst type="venstre">Denne vil åpnes til venstre for knappen.</Hjelpetekst>
<Hjelpetekst type="hoyre">Denne vil åpnes til høyre for knappen.</Hjelpetekst>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      